/**
 * components/auth/AuthGate.tsx
 * Wraps app content and shows login if not authenticated.
 */

import React, { useEffect } from 'react'
import { useAuthStore } from '../../store/auth'
import { useUserStore } from '@/store/user'
import { LoginCard } from './LoginCard'
import { supabase } from '@/lib/supabaseClient'
import { set } from 'date-fns'

/**
 * AuthGate
 * If no current user -> show login overlay. Else render children.
 */
export  function AuthGate({ children }: { children: React.ReactNode }) {
  //const currentUser = useAuthStore((s) => s.getCurrentUser())
  
  
  const [loginFlag, setLoginFlag] = React.useState(false);
  const username = useUserStore((s) => s.username)
  /* Check if token is there */
  /* Rehydrate user state */
  const rehydrate = useUserStore((s) => s.rehydrate)
  const hydrate = async () => {
    const user = (await supabase.auth.getSession()).data.session?.user
    if(user) {
      console.log("Rehydrating user with ID:", user.id);
      await rehydrate(user.id);
      setLoginFlag(true);
    }
  }

  useEffect(() => {
    hydrate()
  }, [])

  console.log("Current User in AuthGate:", username);
  if (!loginFlag && !username) {
    return (
      <div className="min-h-screen bg-slate-50 text-slate-900">
        <div className="mx-auto flex min-h-screen max-w-7xl items-center justify-center px-4">
          <LoginCard />
        </div>
      </div>
    )
  }

  return <>{children}</>
}
